export default __webpack_public_path__ + "static/media/iconAsc.6ea6fce0.svg";